import $ from 'jquery'

class TableOverflow {
    constructor(el) {
        let overflowEl = $('<div class="c-table-overflow"></div>')
        $(el).wrap(overflowEl)
    }
}

export default TableOverflow